<template>
  <div :class="mobile ? 'mobile-sidebar' : 'sidebar'">
    <nav>
      <ul>
        <li>
          <router-link :to="{ name: 'home' }">
            Home
          </router-link>
        </li>
        <li v-if="userData">
          <router-link :to="{ name: 'profile', params: { id: userData.id } }">
            Your Profile
          </router-link>
        </li>
        <li
          v-if="userData"
          :class="{ highlighting: highlighting }"
        >
          <router-link :to="{ name: 'favorites', params: { id: userData.id } }">
            Favorites
          </router-link>
        </li>
        <li><a href="javascript:alert('COMING SOON')">Advertise</a></li>
        <li>
          <router-link :to="{ name: 'sold_listings' }">
            Sold Listings
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'looking' }">
            Looking to Buy
          </router-link>
        </li>
      </ul>

      <hr v-if="mobile">

      <ul>
        <li class="sidebar-section-name">
          For Sale
        </li>
        <li v-if="userData">
          <router-link :to="{ name: 'user_listings' }">
            Your Listings
          </router-link>
        </li>
        <li>
          <router-link :to="{ name: 'all_listings' }">
            All For Sale
          </router-link>
        </li>
        <template v-if="categories.results">
          <li
            v-for="category of categories.results"
            :key="`sidebarCategory${category.id}`"
          >
            <router-link
              :to="{
                name: 'listing_category', params: { categorySlug: category.slug }
              }"
            >
              {{ category.name }}
            </router-link>
          </li>
        </template>
        <li v-else-if="categories.loading">
          <spinner color="var(--blue-light)" />
        </li>
        <li
          v-else-if="categories.error"
          class="small"
          role="alert"
        >
          <p>
            Failed to load categories. Please check your connection and try
            again.
          </p>

          <button
            type="button"
            class="btn btn-outline-primary btn-sm"
            @click="$store.dispatch('categories')"
          >
            Try Again
          </button>
        </li>
      </ul>

      <hr v-if="mobile">

      <ul v-if="userData">
        <li class="sidebar-section-name">
          Groups
        </li>
        <li>
          <router-link :to="{name: 'all_groups'}">
            All Groups
          </router-link>
        </li>
        <li
          v-for="group in userGroups"
          :key="group.id"
        >
          <router-link :to="{name: 'group_detail', params: {id: group.id}}">
            {{ group.name }}
          </router-link>
        </li>
      </ul>

      <p class="small">
        <router-link :to="{ name: 'flatpage', params: { slug: 'rules' } }">
          Rules
        </router-link>
        <template v-if="isAdmin">
          &bull;
          <router-link
            :to="{name: 'admin'}"
          >
            Admin
          </router-link>
        </template>
        &bull;
        <router-link :to="{ name: 'flatpage', params: { slug: 'privacy' } }">
          Privacy
        </router-link>
        <br>
        <router-link :to="{ name: 'flatpage', params: { slug: 'terms-of-service' } }">
          Terms of Service
        </router-link>
        &bull;
        <router-link :to="{ name: 'flatpage', params: { slug: 'contact' } }">
          Contact
        </router-link>
      </p>
    </nav>

    <div class="small">
      &copy; {{ new Date().getFullYear() }} Gun Group
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Sidebar',
  props: {
    mobile: { type: Boolean, default: false },
  },
  data() {
    return {
      highlighting: false,
    };
  },
  computed: {
    isAdmin() {
      return (this.userData && this.userData.is_staff) || this.isGroupAdmin;
    },
    isGroupAdmin() {
      return this.userGroups.some(g => g.is_admin);
    },
    ...mapState([
      'categories',
      'newFav',
    ]),
  },
  watch: {
    newFav() {
      this.highlightFavorite();
    },
  },
  methods: {
    highlightFavorite() {
      this.highlighting = true;
      setTimeout(() => {
        this.highlighting = false;
        this.$store.dispatch('set_new_fav', false);
      }, 500);
    },
  },
};
</script>

<style lang="scss" scoped>
  li a {
    display: block;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  .highlighting {
    animation-name: scale;
    animation-duration: .5s;
    animation-iteration-count: 1;
    animation-timing-function: ease-in;
    animation-fill-mode: forwards;
  }

  @keyframes scale {
    0% {
      padding-left: 0px;
      background-color: transparent;
    }

    50% {
      padding-left: 5px;
      background-color: yellow;
    }

    100% {
      padding-left: 0px;
      background-color: transparent;
    }
  }
</style>
